import { render, staticRenderFns } from "./PromotionSimpleField.vue?vue&type=template&id=2f66b0aa"
import script from "./PromotionSimpleField.vue?vue&type=script&lang=js"
export * from "./PromotionSimpleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports